import React, { Component, Fragment } from "react";
import './SolicitacaoAdesaoArquivosGrandesVoumes.css';
import { SecureDirectoryClientInformationDetail } from "../SecureDirectory/SecureDirectoryClientInformationDetail";

export const SolicitacaoAdesaoArquivosGrandesVolumesDetails =

class extends Component {

	render() {
		return (
			<div>
				{this.renderForm()}
			</div>
		);
	}

	renderForm() {
		const { solicitacao, mostraDetalhesAprovacao, mostraDetalhesPastaSegura } = this.props;

		return(
			<div className="br-form">
				<div className="row">
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Número:</label>
								<input value={solicitacao.numero} readOnly/>
							</div>
						</div>
					</div>
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Órgão solicitante:</label>
								<input value={solicitacao.nomeOrgao} readOnly/>
							</div>
						</div>
					</div>
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Situação:</label>
								<input value={solicitacao.nomeSituacao} readOnly/>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Órgão cedente dos dados:</label>
								<input value={solicitacao.nomeOrgaoConjuntoArquivo} readOnly/>
							</div>
						</div>
					</div>

					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Conjunto de Arquivos:</label>
								<input value={solicitacao.tituloConjuntoArquivo} readOnly/>
							</div>
						</div>
					</div>

					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Descrição do Conjunto de Arquivos:</label>
								<textarea value={solicitacao.descricaoConjuntoArquivo} readOnly style={{height:"90px"}}/>
							</div>
						</div>
					</div>
				</div>

				{(solicitacao.arquivos.length > 0) &&	
					<Fragment>
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Arquivos:</label>

										<div className="br-table">						
											<div className="table">
												<table>
													<thead>
														<tr>
															<th scope="col">Nome</th>
															<th scope="col">Descrição</th>
															<th scope="col">Formato</th>
															<th scope="col" className="text-right">Tamanho em MB</th>
															<th scope="col">Periodicidade</th>
															<th scope="col">Ação</th>
														</tr>
													</thead>
													
													<tbody>
														{ solicitacao.arquivos.map((arquivo, index) =>
																<tr key={index} className={arquivo.orgaoPossuiAdesaoArquivo ? "tr-bold" : ""}>
																	<td style={{width: "20%"}}>{arquivo.nome}</td>
																	<td>{arquivo.descricao}</td>
																	<td style={{width: "10%"}}>{arquivo.nomeExtensaoArquivo}</td>
																	<td style={{width: "10%"}} className="text-right">{arquivo.tamanho}</td>
																	<td style={{width: "10%"}}>{arquivo.nomePeriodicidade}</td>
																	<td style={{width: "10%"}}>{arquivo.nomeArquivoOperacao}</td>
																</tr>
															)}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</Fragment>
				}


				<div className="row">
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Dirigente de TI:</label>
								<input value={solicitacao.nomeDirigenteTi} readOnly/>
							</div>
						</div>
					</div>
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Responsável Técnico:</label>
								<input value={solicitacao.nomeResponsavelTecnico} readOnly/>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md">  
						<div className="field">
							<div className="input"> 
								<label htmlFor="finalidade">Finalidade:</label>
								<textarea value={solicitacao.finalidade} readOnly style={{height:"300px"}}/>
							</div>
						</div>
					</div>
				</div>

				{mostraDetalhesPastaSegura &&
					<SecureDirectoryClientInformationDetail solicitacao={solicitacao} />
				}

				{mostraDetalhesAprovacao &&
					<Fragment>
						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="justificativaOrgaoFornecedor">Justificativa cedente dos dados:</label>
										<textarea value={solicitacao.justificativaOrgaoFornecedor} readOnly={true} onChange={this.handleInputChange} maxLength={255} style={{height:"90px"}} />
									</div>
								</div>
							</div>

							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="justificativaOrgaoAdministrador">Justificativa conecta:</label>
										<textarea value={solicitacao.justificativaOrgaoAdministrador} readOnly={true} style={{height:"90px"}} />
									</div>
								</div>
							</div>
						</div> 
					</Fragment>
				}
			</div>
		);
	}
}
